import axios from 'axios';

const ajaxLoadMore = () => {
    
    let button = document.querySelector( '.load-more' );

    const currentPage = document.querySelector('.post-list');
    const maxPage = document.querySelector('.post-list');
    
    if( button ) {
        if ( currentPage.dataset.page === maxPage.dataset.max ) {
            button.parentNode.removeChild(button);
        }
    }

    if ( typeof (button) != 'undefined' && button != null ) {
        button.addEventListener( 'click', (e) => {
            // console.log( 'Clicked' );
            const current_page      = document.querySelector( '.post-list' ).dataset.page;
            const product_category  = document.querySelector( '.post-list' ).dataset.category;
            const sort_order        = document.querySelector( '.post-list' ).dataset.sortorder;
            const search_value      = document.querySelector( 'input[type="search"].orig' ).value;

            let getUrl = window.location;
            // console.log( getUrl );

            let params = new URLSearchParams();

            // If Page is News, Then Load More Posts Action.
            if( getUrl.pathname === "/news/" ) {
                params.append( 'action', 'load_more_posts' );
            } 

            // If Page is Our Brands, Then Load More Brands Action.
            if( getUrl.pathname === "/our-brands/" ) {
                params.append( 'action', 'load_more_brands' );
            } 

            // If Page is Products, Then Load More Brands Action. (Post Type Archive: Product)
            if( getUrl.pathname === "/products/" ) {
                params.append( 'action', 'load_more_products' );
            } 


            if( product_category ) {
                params.append( 'product_category', product_category );
            }

            if( sort_order ) {
                params.append( 'sort_order', sort_order );
            }

            if( search_value ) {
                params.append( 'search_value', search_value );
            }

            params.append( 'current_page', current_page );

            
            axios.post( '/wp-admin/admin-ajax.php', params )
            .then( res => {

                let posts_list = document.querySelector('.news-list');
                posts_list.insertAdjacentHTML("beforeend", res.data.data);;

                

                
                // let baseUrl = getUrl.protocol + "//" + getUrl.host + "/";
                // window.history.pushState('', '', baseUrl + 'page/' + (parseInt(currentPage.dataset.page) + 1));

                currentPage.dataset.page++;
                
                if ( currentPage.dataset.page === maxPage.dataset.max ) {
                    button.parentNode.removeChild(button);
                }
                
                
            } );


        } );
    }
} 

export default ajaxLoadMore;